import React from 'react';

import { InfoLabel, InfoLine } from './styles';

const EMPTY_VALUE = '-';

interface LineProps {
	label: string;
	value?: string;
}

export function Line({ label, value }: Readonly<LineProps>): JSX.Element {
	return (
		<InfoLine>
			<InfoLabel>{`${label}: `}</InfoLabel>
			{value || EMPTY_VALUE}
		</InfoLine>
	);
}
